import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { noDataImg, IMG_DEFAULT } from "../../common/baseConfig";
import * as actions from './redux/actions';
import { Button, List } from "antd";

export class CourseManageMyCourses extends Component {
  state = {
    curPage: 1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.onLoadMyCourses();
  }
  onLoadMyCourses() {
    this.props.actions.fetchGetMyCourse({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
    })
  }
  renderItem(item) {
    return (
      <div key={item.ID} className="my-course-list-item">
        <div className="content">
          <img src={item.CoverPath ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_90,w_160' : IMG_DEFAULT} alt="" />
          <h1>
            <p>{item.Name}</p>
            <p>已学<span>{item.LookHours >= item.SumHours ? "100" : ((item.LookHours / item.SumHours) * 100).toFixed(2)}%</span></p>
          </h1>
        </div>
        <div className="right">
          {
            item.IsPay === 2 &&
            <p>退款中</p>
          }
          <Button type="theme" className="goStudyBtn" disabled={item.IsPay === 2} onClick={() => {
            this.props.history.push(`/course/detail/${item.ID}`);
          }}>进入学习</Button>
        </div>
      </div>
    )
  }
  render() {
    const { fetchGetMyCourseSuccess, fetchGetMyCourseTotal, fetchGetMyCoursePending } = this.props.center;

    return (
      <div className="center-course-manage-my-courses">
        {
          fetchGetMyCourseSuccess && fetchGetMyCourseSuccess.length > 0 ?
            <div className="my-course-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadMyCourses();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetMyCourseTotal,
                  pageSize: 5,
                }}
                loading={fetchGetMyCoursePending}
                dataSource={fetchGetMyCourseSuccess}
                renderItem={item => this.renderItem(item)}
              />
            </div>
            :
            <div className="nodata">
              <img src={noDataImg} alt="" />
              <p>您没有报名任何课程~</p>
              <p>学习没有终点,任何时候都是一个起点~</p>
              <Button type="theme2" className="studyBtn" onClick={() => {
                this.props.history.push('/courseList');
              }}>马上学习</Button>
            </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseManageMyCourses);



// WEBPACK FOOTER //
// ./src/features/center/CourseManageMyCourses.js